import { GlobalEnumsAcePortaltyp } from '@/api/model-index';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { StammdatenService } from '@/core/services/stammdaten.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class PortalTypGuard implements CanActivate {
    constructor(protected stammdatenService: StammdatenService, protected router: Router, protected loadingAnimationService: LoadingAnimationService) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let portaltyp = route.data.portaltyp as GlobalEnumsAcePortaltyp;
        const portalkonfiguration = await this.stammdatenService.GetPortalKonfiguration().toPromise();

        if (portalkonfiguration) {
            if (portalkonfiguration.portalTyp == portaltyp) {
                return true;
            }
            else {
                // Hole die Schwester-Routen
                const siblingRoutes = route.parent?.routeConfig?.children;

                if (siblingRoutes && siblingRoutes.length > 1) {
                    // Filtere nur die Routen, die denselben Guard in `canActivate` haben
                    const validSiblings = siblingRoutes.filter(r => {
                        return r.canActivate?.some(guard => guard === PortalTypGuard);
                    });

                    if (validSiblings.length > 1) {
                        // Finde die aktuelle Route
                        const currentIndex = validSiblings.findIndex(
                            (r) => r.path === route.routeConfig?.path
                        );

                        // Berechne den Index der nächsten gültigen Schwester-Route (zyklisch)
                        const nextIndex = (currentIndex + 1) % validSiblings.length;
                        const nextSiblingPath = validSiblings[nextIndex].path;

                        // Navigiere zur nächsten Schwester-Route
                        if (nextSiblingPath != undefined) {
                            let promise = this.router.navigateByUrl(nextSiblingPath);
                            this.loadingAnimationService.showSpinnerUsingPromise(promise);
                            return true;
                        }
                    }
                }
            }
        }

        return false;
    }
}